'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onEdit", "onUnlink", "href"];
import PropTypes from 'prop-types';
import { useState } from 'react';
import { PopoverBodyLiteIcons } from '../../constants/popover';
import { LinkTypes } from '../../constants/link';
import PopoverBodyLiteBase from '../PopoverBodyLiteBase';
import LinkPreview from './LinkPreview';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.links.lite.${suffix}`;
const propTypes = Object.assign({
  onEdit: PropTypes.func.isRequired,
  onUnlink: PropTypes.func.isRequired
}, LinkPreview.propTypes);
function EditLinkPopoverBodyLite(props) {
  const {
      onEdit,
      onUnlink,
      href
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [iconButtons] = useState([{
    iconName: PopoverBodyLiteIcons.EDIT,
    onClick: onEdit
  }, {
    iconName: PopoverBodyLiteIcons.UNLINK,
    onClick: onUnlink
  }]);
  const Preview = href ? /*#__PURE__*/_jsx(LinkPreview, Object.assign({}, rest, {
    href: href,
    className: "p-left-3 " + (props.linkType === LinkTypes.ANCHOR ? 'p-right-2' : 'p-right-1'),
    alignSelf: "center"
  })) : null;
  return /*#__PURE__*/_jsx(PopoverBodyLiteBase, {
    "data-test-id": "edit-link-popover-body-lite",
    iconButtons: iconButtons,
    i18nKey: i18nKey,
    children: Preview
  });
}
EditLinkPopoverBodyLite.propTypes = propTypes;
EditLinkPopoverBodyLite.displayName = 'EditLinkPopoverBodyLite';
export default EditLinkPopoverBodyLite;